<template>
  <div>
    <v-card style="border-radius:12px;">
      <v-row class="px-5">
        <v-col cols='6' style="border-right: solid 1px #ccc; cursor: pointer" @click="openEditEmployeeDialog(item)">
          <div>
            {{item.name}}
          </div>
          <div>
            {{ item.company_name || 'Gerdau'}}
          </div>
        </v-col>
        <v-col cols='6' align='center' style="border-left: solid 1px #ccc">
          <v-row align="center" class="px-3 py-2" justify='center'>
            <span :class="[current_answer_icon.color+'--text', 'text-truncate']">
              <v-icon v-if="current_answer_icon" :color="current_answer_icon.color">{{current_answer_icon.icon}}</v-icon>
              <span v-if="current_answer">{{current_answer_code}} - {{current_answer_text}}</span>
              <span v-if="!current_answer" class="grey--text text--lighten-1">sem avaliação</span>
            </span> 
            <v-select
              v-if="false"
              :loading="loading"
              :items="all_categories"
              v-model="current_grade"
              item-value="id"
              item-text="name"
              label="Avaliação"
            >
              <template v-slot:item="data">
                <v-list-item v-on="data.on" :attrs="data.attrs">
                  <v-list-item-title :class="data.item.kind == 'I'? 'red--text':'success--text'">
                    <div>
                      {{data.item.id}}- {{data.item.name}}
                    </div>
                  </v-list-item-title>
                </v-list-item>
              </template>
            </v-select>
          </v-row>
            <v-btn small outlined rounded @click="dialog=true" :disabled="is_execution_closed" color="primary">{{current_answer? 'Reavaliar' : 'Avaliar'}}</v-btn>
        </v-col>
      </v-row>
    </v-card>

    <dialog-select-category v-if="dialog" :item="item" :item_idx="item_idx" :base_value='current_grade' @selectedCat="handleSelected" @close="handleClose"></dialog-select-category>
    <dialog-edit-employee v-if="edit_employee_dialog" :dialog="edit_employee_dialog" :employee="edit_employee" @closeEditEmployee="handleCloseEditEmployee()"></dialog-edit-employee>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations} from 'vuex';

export default {
  components: { 
    DialogSelectCategory: () => import('./DialogSelectCategory.vue'),
    DialogEditEmployee: () => import('./DialogEditEmployee.vue')
  },
  name: 'EmployeeCard',
  props: {
    item: {
      type: Object,
    },
    item_idx: {
      type: Number,
    },
  },
  data() {
    return {
      loading: false,
      local_item: {},
      current_grade: null,
      dialog: false,
      edit_employee_dialog: false,
      edit_employee: null
    }
  },
  methods: {
    handleCloseEditEmployee() {
      this.edit_employee = null;
      this.edit_employee_dialog = false;
    },
    openEditEmployeeDialog(employee) {
      this.edit_employee = {...employee};
      this.edit_employee_dialog = true;
    },
    getCategories() {
      this.loading_categories = true;
      this.indexCategories().then(() => {
        this.loading_categories = false;
      })
    },
    handleSelected(e){
      this.current_grade = e
      this.dialog = false
    },
    handleClose(){
      this.dialog = false
    },
    setupLocalItem(){
      if (this.item){
        this.local_item = {...this.item}
      }
    },
    setGrade(val){
      let obj = {
        employee_idx: this.item_idx,
        employee_ref: this.local_item.local_ref,
        time_idx: this.current_time_idx,
        grade: val,
      }
      console.log({obj});
      this.setGradeTime(obj)
    },
    ...mapActions({
      indexCategories: 'Category/index',
      setGradeTime: 'Execution/setGradeTime'
    }),
    ...mapMutations({
      setCurrentTime: 'Execution/setCurrentTime',
      // setGradeTime: 'Execution/setGradeTime',
      // function: 'Module/action'
    })
  },
  mounted () {
    this.getCategories();
    this.setupLocalItem();
  },
  computed: {
    is_execution_closed() {
      let status = this.current_execution.status;
      if (status == 'closed') {
        return true;
      } else {
        return false;
      }
    },
    current_answer(){
      return this.current_execution.employees[this.item_idx].grade_time[this.current_time_idx]
    },
    current_answer_code() {
      let cat =  this.all_categories.find( c=> c.id == this.current_answer)
      if (cat){
        return cat.code
      }
      return null
    },
    current_answer_text(){
      let cat =  this.all_categories.find( c=> c.id == this.current_answer)
      if (cat){
        return cat.name
      }
      return null
    },
    current_answer_icon(){
      if (this.current_time && this.all_categories && this.local_item && this.local_item.grade_time){
        let cat = this.all_categories.find(cat => cat.id == this.current_execution.employees[this.item_idx].grade_time[this.current_time_idx])
        if (cat){
          let icon_map = {
            I: {
              icon: 'mdi-trending-down',
              color: 'error',
            },
            P: {
              icon: 'mdi-trending-up',
              color: 'success',
            }
          }
          return icon_map[cat.kind]
        }
      }
      return {
              icon: 'mdi-trending-neutral',
              color: 'grey',
            }
    },
    employees() {
      if (this.current_execution && this.current_execution.employees.length){
        return this.current_execution.employees
      }
      return [] 
    },
    ...mapState({
      all_categories: state => state.Category.all_categories,
      current_execution: state => state.Execution.current_execution,
      current_time: state => state.Execution.current_time,
      current_time_idx: state => state.Execution.current_time_idx,
      profile: state => state.User.profile,
      // data: state=> state.Module.state_var
    }),
  },
  watch: {
    current_time_idx(nv, ov) {
      let idx = nv || 0
      this.loading = true
        setTimeout(() => {
          this.current_grade = this.current_execution.employees[this.item_idx].grade_time[idx] || null
          this.loading = false
        }, 100);
      if(nv){
      }
    },
    current_time(nv, ov) {
      if(nv){
      }
    },
    current_grade(nv,ov){
      if (nv){
        this.setGrade(nv)
      }
    }
  },

}
</script>

<style lang="scss" scoped>

</style>